<template>
  <div id="app">
    <el-row>
      <el-col :span="20">
Passo 4 - VISUALIZAR PROPOSTA

      </el-col>
    </el-row>
        <el-row>
      <el-col :span="16">
<el-card class="box-card">
<el-row><el-col :span="24">
    <el-row>
      <el-col  :span="12" class="texto_esquerda">
        <h3>Proposta NBRTec: Versão: 01</h3>
      </el-col>
      <el-col :span="12" class="texto_esquerda">
        <h3>Panambi, 09 de Novembro de 2020</h3>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="texto_esquerda">
        <h3>Cliente: Saur</h3>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="texto_esquerda">
        <h3>Local: Panambi-RS</h3>
      </el-col>
    </el-row>    
    <el-row>
      <el-col :span="24" class="texto_esquerda">
        <h3>A/C:</h3>
      </el-col>
    </el-row>    
    <el-row>
      <el-col :span="24" class="texto_esquerda">
        <h3>E-mail:</h3>
      </el-col>
    </el-row>    
    <el-row>
      <el-col :span="24" class="texto_esquerda">
        <h3>Telefone:</h3>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" >
<h1 style='text-align:center;'>PROPOSTA COMERCIAL</h1>
<h2 style='text-align:center;'>Referente ao fornecimento de quadro de comando.</h2>
<br>
<p  class="texto_esquerda">Agradecemos a oportunidade, e nos mantemos a disposição para quaisquer esclarecimentos, alterações e negociações.</p>
<br><br>
      </el-col>
    </el-row>
    <el-row>
      <el-col  :span="12" class="texto_esquerda">
        <h3>Supervisor Comercial</h3>
        <br><br>
        <p style="margin-top:0px; margin-bottom:0px;">__________________________________________</p>
        <p style="margin-top:0px; margin-bottom:0px;">Otmar Christmann</p>
        <p style="margin-top:0px; margin-bottom:0px;">otmar@nbrtec.com.br</p>
        <p style="margin-top:0px; margin-bottom:0px;">Celular: (55) 99114-4187</p>
      </el-col>
      <el-col :span="12" class="texto_esquerda">
        <h3>Responsável Técnico</h3>
        <br><br>
        <p style="margin-top:0px; margin-bottom:0px;">__________________________________________</p>
        <p style="margin-top:0px; margin-bottom:0px;">Patricia P. Silva</p>
        <p style="margin-top:0px; margin-bottom:0px;">patricia@nbrtec.com.br</p>
        <p style="margin-top:0px; margin-bottom:0px;">(55) 3375-7773</p>
      </el-col>
    </el-row>

    <el-row>
      <el-col  :span="24" class="texto_esquerda">
        <br><br>
<el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="historico"
        label="Histórico das revisões"
        width="400">
      </el-table-column>
      <el-table-column
        prop="rev"
        label="Rev"
        width="80">
      </el-table-column>
      <el-table-column
        prop="orc"
        label="Orc.">
      </el-table-column>
      <el-table-column
        prop="data"
        label="Data">
      </el-table-column>
    </el-table>
      </el-col>

    </el-row>



</el-col></el-row>      
</el-card>
        </el-col>
    </el-row>  
  </div>
</template>

<script>

export default {
   data() {
        return {
          tableData: [{
            historico: 'Emissão Inicial',
            rev: '00',
            orc: 'PS',
            data: '08/04/2020'
          }]
        }
      }
  
};
</script>
<style scoped>
.texto_esquerda {
  text-align: left;
  margin-top:0px;
  margin-bottom:0px;
}
.texto_esquerda h3 {
  text-align: left;
  margin-top:0px;
  margin-bottom:0px;
}
</style>

